import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "modal-content" }
const _hoisted_2 = { class: "modal-title px-2" }
const _hoisted_3 = { class: "modal-body" }
const _hoisted_4 = { class: "modal-footer" }

import { ref, onMounted, watch } from 'vue'
import { Modal } from 'bootstrap'


export default /*#__PURE__*/_defineComponent({
  __name: 'Modal',
  props: {
    modelValue: { type: Boolean },
    title: {},
    colorTitle: {},
    bgcolor: {},
    width: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const modalRef = ref<HTMLElement | null>(null)
let modal: Modal
onMounted(() => {
  if (modalRef.value) {
    modal = new Modal(modalRef.value)
  }
})

watch(() => props.modelValue, (modelValue) => {
  if (modelValue) {
    modal.show()
  } else {
    modal.hide()
  }
})

function close() {
  
  emit('update:modelValue', false)

}
function open() {
  emit('update:modelValue', true)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    tabindex: "-1",
    "aria-hidden": "true",
    ref_key: "modalRef",
    ref: modalRef,
    role: "dialog",
    onClick: _withModifiers(close, ["self"])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass('modal-dialog modal-'+_ctx.width),
      role: "document",
      onClick: _withModifiers(close, ["prevent","self"])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "modal-header",
          style: _normalizeStyle({'background-color': _ctx.bgcolor, 'color': _ctx.colorTitle})
        }, [
          _createElementVNode("h5", _hoisted_2, _toDisplayString(_ctx.title), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close btn-close-white mx-2",
            id: "fermeture",
            "aria-label": "Close",
            onClick: close
          })
        ], 4),
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "footer")
        ])
      ])
    ], 2)
  ], 512))
}
}

})